<template>
  <a
    class="text-secondary font-bold"
    :href="href"
  >
    <slot />
  </a>
</template>

<script>
export default {
  name: 'Link',

  props: {
    href: {
      required: true,
      type: String,
    },
  },
};
</script>
